import RepositoryService from 'src/services/repository'

const resource = 'trainingSession/player'

export default RepositoryService.utils.createCrudRepository(resource)
